import { HTTPMethod } from '@perpay-web/constants/httpMethods';
import { useDataModule } from '@perpay-web/data-module/useDataModule';
import { useReduxDataModuleHookConnection } from '@perpay-web/data-module/useReduxDataModuleHookConnection';
import {
    verifyNewPhoneNumberContext,
    verifyNewPhoneNumberContextSuccess,
    verifyNewPhoneNumberContextError,
    verifyNewPhoneNumberContextReset,
} from '@perpay-web/fintech/actions/entities/phoneNumber';
import { UPDATE_AND_VERIFY_PHONE_ENDPOINT } from '@perpay-web/fintech/constants/urls';
import { authenticatedJsonFetch } from '@perpay-web/fintech/utils/requestHandlers';
import { hookAction$ } from '@perpay-web/services/singletons';
import { createContextProvider } from '@perpay-web/utils/componentUtils';

const useVerifyNewPhoneNumberDataModule = () => {
    const dataModule = useDataModule((payload) =>
        authenticatedJsonFetch(
            `${UPDATE_AND_VERIFY_PHONE_ENDPOINT}`,
            payload,
            HTTPMethod.put,
        ),
    );

    useReduxDataModuleHookConnection({
        dataModule,
        hookAction$,
        request: verifyNewPhoneNumberContext,
        error: verifyNewPhoneNumberContextError,
        success: verifyNewPhoneNumberContextSuccess,
        reset: verifyNewPhoneNumberContextReset,
    });

    return dataModule;
};
const providerFactory = (Context) => {
    const Provider = ({ children }) => {
        const dataModule = useVerifyNewPhoneNumberDataModule();

        return (
            <Context.Provider value={dataModule}>{children}</Context.Provider>
        );
    };

    return Provider;
};

export const [
    UseVerifyNewPhoneNumberDataModuleProvider,
    useVerifyNewPhoneNumberContext,
] = createContextProvider(providerFactory);
